const formDefaults = require('./formDefaults');

module.exports = {
    ...formDefaults
};
